import type { FeaturedCarouselTyped } from '@setplex/tria-api'
import type { Store } from 'effector'
import type { ShowWithPrice } from '~/shared/interfaces'

import { api } from '@setplex/tria-api'
import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'
import { register } from '~/core/repository'
import { formatFeaturedRowShows } from '~/entities/shows/featured/lib'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'

export const $featuredTvShowsFormatted: Store<
  FeaturedCarouselTyped<ShowWithPrice>[]
> = combine(
  api.banners.$featuredCarouselTypeTvShow,
  ssePurchasesModel.$tvShow,
  i18n.$t,
  (carousels, adjust) => {
    if (carousels?.length === 0) return []

    return carousels.map((category) => {
      return {
        ...category,
        content: formatFeaturedRowShows(category.content, adjust),
      } as FeaturedCarouselTyped<ShowWithPrice>
    })
  }
)

export const $featuredTvShowsTitle: Store<string> = combine(i18n.$t, ({ t }) =>
  t('series_featured')
)

register($featuredTvShowsTitle, '$featuredTvShowsTitle')
register($featuredTvShowsFormatted, '$tvShowFeaturedCarousel')
